var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 90,
    viewBox: "0 0 266 90",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.911 88.6016H15.7263C13.1389 88.6016 11.0375 85.6943 11.0375 82.1147V76.3546C11.0375 72.5751 8.8047 69.5407 6.07286 69.5952L2.82879 69.6678C0.963777 69.7042 -0.0869303 66.706 1.10825 64.7073L8.30562 52.6602C10.0787 49.6984 11.0375 45.9916 11.0375 42.1394V7.08846C11.0375 3.50886 13.1389 0.601562 15.7263 0.601562H259.911C262.499 0.601562 264.6 3.50886 264.6 7.08846V82.0783C264.6 85.6579 262.499 88.5652 259.911 88.5652V88.6016Z",
    stroke: "#058794",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.f1ada4361919542bf487fa83b5b0f333.svg";
export { ForwardRef as ReactComponent };